<script lang="ts" module>
  import CardLoading from './CardLoading.svelte';

  export namespace LoadingCards {
    export interface Props {
      loading: boolean;
      count: number;
    }
  }
</script>

<script lang="ts">
  let { loading, count }: LoadingCards.Props = $props();
</script>

{#if loading}
  {#each Array(count) as _, i (i)}
    <div class="flex h-12">
      <CardLoading></CardLoading>
    </div>
  {/each}
{/if}
